import React, {useEffect, useState} from 'react';
import {Grid, Typography} from '@mui/material';
import Money from 'js-money';
import {DAYS_PER_MONTH} from '../constants/securspace-constants';
import {styled} from "@mui/material/styles";

const LocationItemGridContainer = styled(Grid)(() => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
}));

const LocationItemGridItem = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  width: '100%'
}));

const LocationItemPricePerMonth = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '1.71428rem',
  lineHeight: '133.4%',
  display: "flex",
  alignItems: "flex-end"
}));

const LocationItemSaveMoney = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '1.1em',
  lineHeight: '157%',
  color: '#F44336',
}));

// Cast back to `typeof Typography` so downstream usage retains Typography's
// polymorphic `component` prop, which `styled()` would otherwise erase.
const LocationItemPerMonth = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '.6em',
})) as typeof Typography;

const LocationItemSecondaryPrice = styled(Typography)(({theme}) => ({
  color: theme.palette.text.secondary,
  fontFamily: 'Inter',
  fontWeight: '500',
  fontSize: '1em',
  lineHeight: '157%',
  letterSpacing: '0.1px',
}));

interface LocationItemPriceDisplayProps {
  pricePerMonth?: number;
  pricePerDay?: number;
}

const LocationItemPriceDisplay = (props: LocationItemPriceDisplayProps) => {
  const {pricePerMonth = 0, pricePerDay = 0} = props;
  const [formattedMonthly, setFormattedMonthly] = useState('');
  const [formattedDaily, setFormattedDaily] = useState('');
  const [formattedSaveMoneys, setFormattedSaveMoneys] = useState('');

  useEffect(() => {
    const currency = Money.USD;
    const moneyPricePerMonth = new Money(pricePerMonth, currency);
    const moneyPricePerDay = new Money(pricePerDay, currency);

    setFormattedMonthly(moneyPricePerMonth.isPositive() ? `${currency.symbol}${moneyPricePerMonth}/mon` : '');

    setFormattedDaily(moneyPricePerDay.isPositive() ? `${currency.symbol}${moneyPricePerDay}/day` : '');

    if (pricePerDay && pricePerMonth) {
      const savings = moneyPricePerMonth.divide(DAYS_PER_MONTH, Math.round).subtract(moneyPricePerDay);
      if (savings.isPositive()) {
        setFormattedSaveMoneys(`Save ${currency.symbol}${savings}/day`);
      }
    }
  }, [pricePerMonth, pricePerDay]);

  return <LocationItemGridContainer container>
    <LocationItemGridItem item>
      <LocationItemPricePerMonth color={'textPrimary'}>
      {formattedMonthly ? formattedMonthly?.split("/")[0] : formattedDaily?.split("/")[0]}
        <LocationItemPerMonth component={"span"}>
        /{formattedMonthly ? formattedMonthly?.split("/")[1] : formattedDaily?.split("/")[1]}
        </LocationItemPerMonth>
      </LocationItemPricePerMonth>
      <LocationItemSecondaryPrice variant="subtitle2">{formattedMonthly && formattedDaily}</LocationItemSecondaryPrice>
    </LocationItemGridItem>
      <LocationItemSaveMoney>{formattedSaveMoneys}</LocationItemSaveMoney>
  </LocationItemGridContainer>
}

export default LocationItemPriceDisplay;
